<template>
  <div class="nav">
    <draggable v-model="itemList"
               :options="{draggable:'.item',disabled:!isEdit}">
      <div class="item"
           :class='{last:key==itemList.length-1 && (key+1)%4!=0 && !isShow,first:key%4==0,active: isEdit} '
           :key="key"
           v-for='(item,key) in itemList'
           @click='linkurl(item)'>
        <p><i class='iconfont'
              :class='item.pic'
              :style='{color:item.color}'></i></p>
        <p>{{item.title}}</p>
        <div class="edit"
             v-show='isEdit'
             @click='deleteItem(item)'><i class="iconfont icon-iconless"></i></div>
        <div class="beta"
             v-if="item.tip">
          <i class="iconfont"
             :class="'icon-'+item.tip"></i>
        </div>
      </div>
      <div class="item"
           :class='{last:(itemList.length+1)%4!=0}'
           v-if='isShow'
           @click='goMoreFunction'>
        <p><i class='iconfont icon-menu'></i></p>
        <p>{{$t('more')}}</p>
      </div>
    </draggable>
    <div class="normalFns"
         v-if='!isShow'>
      <div class="normalFn"
           v-for='item in myFuncitons'
           :key="item.id">
        <h1 v-if="item.funtions && (item.funtions.length > 0)"><i class='iconfont icon-changfangxingbiaoqian'></i>{{item.name}}</h1>
        <div @click="linkurl(funtion)"
             class="item"
             v-for='(funtion,key) in item.funtions'
             :key="key"
             :class='{last:key==item.funtions.length-1 && (key+1)%4!=0 ,first:key%4==0,active: isEdit}'>
          <p><i class='iconfont'
                :class='funtion.pic'
                :style='{color:funtion.color}'></i></p>
          <p>{{funtion.title}}{{item.url}}</p>
          <div class="edit add"
               :class='{gray:funtion.favorite}'
               v-show='isEdit'
               @click='addItem(funtion)'>
            <span :class='{right:funtion.favorite}'>
              <i class="iconfont icon-right"
                 v-if="funtion.favorite"></i>
              <i class="iconfont icon-jiahao"
                 v-else></i>
            </span>
          </div>
          <div class="beta"
               v-if="funtion.tip">
            <i class="iconfont"
               :class="'icon-'+funtion.tip"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import _ from "lodash";
  import draggable from "vuedraggable";
  import {
    MessageBox, Toast
  } from "mint-ui";
  import ajaxGet from "@/conf/ajaxGet";
  import newPermissionIcon from "@/conf/newPermissionIcon";
  import moment from "moment";

  export default {
    data() {
      return {
        isShow: this.$route.name != "moreFunction", //是否在首页
        myFuncitons: [],
        perArr:newPermissionIcon
      };
    },
    props: ["isEdit"],
    mounted() {
      const self = this
      this.itemList = [];
      if (this.$store.state.myList.myList.length == 0) {
        this.$http.get("/mobilepmsapi/sys/myFavoriteFunciton").then(res => {
          if (res.data.result == 0) {
            var arr = res.data.retVal || []
            if(localStorage.getItem('useMhPermission') == 'yes'){
              this.itemList = self.filterFavUrl(arr)
            } else {
              this.itemList = arr;
            }
            localStorage.setItem("myList", JSON.stringify(arr));
          }
        });
      }
      if (!this.isShow) {
        if(localStorage.getItem('useMhPermission') == 'yes'){
          // 使用新权限
          this.$http.get('/mobilepmsapi/sys/myFuncitonNew').then(res => {
            if (res.data.result == 0) {
              this.filterNewUrl(res.data.retVal || [])
            }
          });
        } else {
          this.$http.get('/mobilepmsapi/sys/myFunciton').then(res => {
            if (res.data.result == 0) {
              this.myFuncitons = res.data.retVal;
            }
          });
        }
      }
    },
    methods: {
      filterFavUrl(arr){
        const self = this
        var permissionMapUrl = this.perArr
        arr.map((item) => {
          if(item.kind == "THIRDURL"){
            item.isActive = true
          }
          permissionMapUrl.map((item3) => {
            if((item3.url == item.url) && self.$hasPermission(item3.newPermission)){
              item.isActive = true
            }
          })
        })
        var temp = arr.filter((item) => {
          return item.isActive
        })
        return temp
      },
      filterNewUrl(functionArr){
        var permissionMapUrl = this.perArr
        const self = this
        console.log('当前返回的图标：',functionArr)
        functionArr.map((item) => {
          var functions = item.funtions || []
          functions.map((item2) => {
            if(item2.kind == "THIRDURL"){
              item2.isActive = true
            }
            permissionMapUrl.map((item3) => {
              if((item3.url == item2.url) && self.$hasPermission(item3.newPermission)){
                  item2.isActive = true
              }
            })
          })
          var temp = []
          functions.map((item) => {
            if(item.isActive) {
              temp.push(item)
            }
          })
          item.funtions = temp
        })
        this.myFuncitons = functionArr;
      },
      goMiniApp(url) {
        if (this.$isApp) {
          var A = plus.webview.getLaunchWebview();
          A.evalJS('openMiniUrl("'+ url +'")');
        } else {
          this.confirm2(this.$t("center_message"), action => {
            location.href = url;
          })
        }
      },

      goMoreFunction() {
        this.$router.push("/moreFunction");
      },
      linkurl(fun) {
        if(localStorage.getItem('isLiCheng') == 'yes'){
          if(fun.url == '/fangQ'){
            fun.url = '/lichengFangQ'
          }
        }
        if (!this.isEdit) {
          // 手机点餐
          if(fun.kind == 'MOBILEORDER'){
            this.doLoginMobileOrdering()
          } else if (fun.kind == 'THIRDURL') { // 第三方链接
            this.goMiniApp(fun.url)
          } else {
            if (this.isShow) {
              this.$router.push(fun.url);
            } else {
              this.$router.push(
                fun.url +
                (fun.url.indexOf("?") > 0 ? "&" : "?") +
                "redirect=/moreFunction"
              );
            }
          }
        }
      },
      deleteItem(item) {
        this.$set(this.itemList, _.pull(this.itemList, item));
        _.forEach(this.myFuncitons, (element, index) => {
          _.forEach(element.funtions, (val, key) => {
            if (item.id == val.id) {
              val.favorite = false;
            }
          });
        });
      },
      addItem(item) {
        if (this.itemList.length >= 11) {
          //"您最多可以增加11个",
          this.msg2(this.$t("Toast_nomorethan11"));
        } else {
          if (!item.favorite) {
            item.favorite = true;
            this.itemList.push(item);
          }
        }
      },

      // 手机点餐登录
      doLoginMobileOrdering() {
        let hasSetUrl = this.hasSetUrl()
        if (hasSetUrl){
          let dcgateway = this.getDcgateway()
          let userInfo = dcgateway.userInfo || {}
          let today = moment().format("YYYY-MM-DD")

          if (userInfo.bizDate && userInfo.bizDate != today){
            this.doReLogin()
          } else {
            if (userInfo.shift) {
              this.doMobileOrderNext()
            } else {
              this.doReLogin()
            }
          }
        } else {
          this.$router.push("/mobileOrdering/networkTest")
        }
      },

      doReLogin(){
        let userInfo1 = this.getLocalUserInfo() || {}
        if (userInfo1.hotelCode && userInfo1.userName && userInfo1.password) {
          this.getSn(this.doLoginMobile);
        } else {
          this.msg2("酒店代码/用户名/密码不能为空！");
        }
      },

      hasSetUrl(){
        let dcgateway = this.getDcgateway()
        return dcgateway.ip && dcgateway.port
      },

      getSn(callback){
        let magicNo = this.$getMagicNo();
        callback(magicNo)
      },

      getLocalUserInfo() {
        let LoginOptionStr = localStorage.getItem('LoginOption')
        let mobileOrderPassword = localStorage.getItem('mobileOrderPassword')
        let LoginOption = JSON.parse(LoginOptionStr || "{}")
        let userInfo = {
          hotelCode: LoginOption.hotelCode || '',
          userName: LoginOption.username || '',
          password: mobileOrderPassword || '', // 密码需要修改，现在的密码是md5化的
        }
        return userInfo
      },

      async doLoginMobile(magicNo) {
        let userInfo = this.getLocalUserInfo() || {}
        let data = {
          params: {
            userName: userInfo.userName,
            password: userInfo.password,
            hotelCode: userInfo.hotelCode,
            magicNo: magicNo || ''
          }
        };
        //console.log("data:", data);
        let res = await ajaxGet("/pos/router?method=loginApp", data);
        if (res && res.resultCode == 0) {
          let dcgateway = this.getDcgateway()
          dcgateway.userInfo = {
            userName: userInfo.userName,
            magicNo: magicNo,
            ...res.data
          };

          localStorage.setItem("dcgateway", JSON.stringify(dcgateway));
          this.$store.commit("submitUserInfo", {
            userName: userInfo.userName,
            magicNo: magicNo,
            ...res.data
          });

          if (res.data.workStationCode) {
            this.doMobileOrderNext()
          } else {
            this.$router.push("/mobileOrdering/siteInfo");
          }
        }
      },

      doMobileOrderNext() {
        let dcgateway = this.getDcgateway()
        let userInfo = dcgateway.userInfo || {}
        if (userInfo.shift) {
          this.$router.push("/mobileOrdering/index");
        } else {
          this.$router.push("/mobileOrdering/selectClass");
        }
      },

      getDcgateway() {
        return localStorage.getItem("dcgateway")
          ? JSON.parse(localStorage.getItem("dcgateway"))
          : {};
      },

    },
    computed: {
      itemList: {
        get() {
          return this.$store.state.myList.myList;
        },
        set(value) {
          this.$store.commit("setMyList", value);
        }
      }
    },
    components: {
      draggable
    }
  };
</script>

<style lang="less"
       scoped>
  body {
    background: #f6f8f9;
  }

  .nav {
    border-top: 1px solid #eee;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-tap-highlight-color: transparent;
    /* For some Androids,个人感觉是低版本的安卓，4.0以下 */
    width: 100%;
    display: flex;
    flex-flow: row wrap;
    align-content: flex-start;

    div {
      width: 100%;
    }

    .normalFn {
      clear: both;

      h1 {
        font-size: 0.3rem;
        color: #666;
        padding: 0.2rem 0.4rem;
        border-top: 1px solid #eee;
        position: relative;
        top: -1px;
      }

      .iconfont {
        color: #f6a624;
        font-size: 0.28rem;
        // margin-right: 0.2rem;
      }
    }

    .iedit {
      border: 1px solid #eee;
    }

    .item {
      background: #fff;
      float: left;
      width: 24.9999999%;
      position: relative;
      box-sizing: border-box;
      text-align: center;
      padding-top: 0.32rem;
      line-height: 0.293333rem;
      border: 1px solid #eee;
      border-top: none;
      border-right: none;
      height: 2.1333rem;
      overflow: hidden;
      margin: 1px 0 0 0;

      &:active {
        background: #eee;
      }

      p {
        padding: 0;
        margin: 0;
        color: #666;
        padding-top: 0.2rem;
        word-break: break-word;
        line-height: 0.4rem;
      }

      .edit {
        width: 0.39rem;
        height: 0.39rem;

        border-radius: 50%;
        color: #fff;
        text-align: center;
        position: absolute;
        right: 0.1rem;
        top: 0.1rem;
        font-weight: bold;
        font-size: 0.5rem;
        vertical-align: middle;
        text-align: center;
        z-index: 1;

        .icon-iconless {
          font-size: 0.39rem;
          color: red;
        }
      }

      .beta {
        position: absolute;
        left: 45%;
        width: 0.8rem;
        top: 0.2rem;

        .iconfont {
          color: red;
          font-size: 0.4rem;
        }
      }

      .add {
        .icon-jiahao {
          color: #4990e2;
          font-size: 0.39rem;
        }
      }

      .gray {
        background: #ccc;
      }

      span {
        display: block;
        text-align: center;
      }

      .right {
        font-size: 0.28rem;
        color: #fff;
        position: relative;
        top: 0rem;
        left: 0.04rem;
      }

      .right .iconfont {
        font-size: 0.3rem;
        color: #fff;
        transform: rotate(-30deg);
      }

      .iconfont {
        font-size: 0.7rem;
      }

      .icon-menu {
        color: #aaa;
      }
    }

    .last {
      border-right: 1px solid #eee;
      width: 25.2%;
    }

    .first {
      border-left: none;
    }

    .sortable-chosen {
      background: #ccc;
    }

    .sortable-ghost {
      background: #aaa;
    }
  }
</style>



// WEBPACK FOOTER //
// myList.vue?18e05800